var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorkProgress(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 25,
    viewBox: "0 0 48 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5766_40347)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 2.25H14.82C14.4 1.09 13.3 0.25 12 0.25C10.7 0.25 9.6 1.09 9.18 2.25H5C3.9 2.25 3 3.15 3 4.25V20.25C3 21.35 3.9 22.25 5 22.25H19C20.1 22.25 21 21.35 21 20.25V4.25C21 3.15 20.1 2.25 19 2.25ZM12 2.25C12.55 2.25 13 2.7 13 3.25C13 3.8 12.55 4.25 12 4.25C11.45 4.25 11 3.8 11 3.25C11 2.7 11.45 2.25 12 2.25ZM19 20.25H5V4.25H7V7.25H17V4.25H19V20.25Z",
    fill: "black",
    fillOpacity: 0.54
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43 3.25H29C27.9 3.25 27 4.15 27 5.25V19.25C27 20.35 27.9 21.25 29 21.25H43C44.1 21.25 45 20.35 45 19.25V5.25C45 4.15 44.1 3.25 43 3.25ZM43 19.25H29V5.25H43V19.25ZM37.96 12.54L35.21 16.08L33.25 13.72L30.5 17.25H41.5L37.96 12.54Z",
    fill: "black",
    fillOpacity: 0.54
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5766_40347"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.25)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkProgress);
export default __webpack_public_path__ + "static/media/work-progress.60e5db3728c0dec21dfd5ab21185a5dc.svg";
export { ForwardRef as ReactComponent };